<script>
//MultiList.vue

export default {
    props: {
        facetTitle: {
            type: String,
            required: true
        },
        filter: {
            type: Object,
            required: true
        },
        options: {
            type: Array,
            required: true
        },
        limitOptions: {
            type: Number,
            required: true
        },
        value: {
            type: String | Number,
        },
        filterOptions: {
            type: Boolean,
            default: false,
        },
        activeFacet: {
            type: Boolean,
            default: true,
        },
        showCounts: {
            type: Boolean,
            default: true,
        }
    },
    data() {
        return {
            id: _.uniqueId(),
            search: '',
            userCollapsed: false,
            cntVisibleOptions: this.limitOptions,
            selectedValue: this.value ?? [],

        }
    },
    watch: {
        value(value) {
            this.selectedValue = value ?? [];
        },
        selectedValue(value, oldValue) {
            if (JSON.stringify(value) !== JSON.stringify(oldValue)) {
                this.$emit('input', value);
            }
        },

    },
    methods: {
        reset() {
            this.search = null;
        },

        isInt(value) {
            return !isNaN(value) &&
                parseInt(Number(value)) === value &&
                !isNaN(parseInt(value, 10));
        }
    },
    computed: {
        selectedValueAll: {
            get: function () {
                return this.selectedValue.length === 0 ? 'all' : this.selectedValue;
            },
            set: function (newValue) {
                if (newValue) {
                    this.selectedValue = [];
                }
            }
        },
        facetKey() {
            return this.$vnode.key;
        },
        filteredList() {
            if (this.search) {
                return this.activeOptions.filter(option => {
                    return option.text.toLowerCase().includes(this.search.toLowerCase()
                    )
                })
            } else {
                return this.activeOptions;
            }
        },
        optionsCount() {
            return this.options ? this.options.length : 0;
        },
        activeOptions() {
            if (this.selectedValue.length) {
                let activeOption = this.options.filter(element => this.selectedValue.indexOf(element.value) !== -1);
                let otherOptions = this.options.filter(element => this.selectedValue.indexOf(element.value) === -1);
                return activeOption.concat(otherOptions);
            } else {
                return this.options;
            }
        },
    }
}
</script>

<template>
    <div>
        <div class="multiList">
            <div v-if="activeFacet">
                <div v-if="filterOptions" class="search-wrapper">
                    <div class="input-group">
                        <input type="text" v-model="search" :placeholder="'Suche Option...'" class="form-control"/>

                        <span class="input-group-addon">
                                    <button @click="reset()" class="btn btn-outline btn-xs" type="button"><i
                                        class="fa fa-eraser"></i></button>
                                </span>
                    </div>
                </div>
                <div>
                    <div class="checkbox checkbox-primary">
                        <input type="checkbox"
                               :id="'all'+id"
                               value="all"
                               v-model="selectedValueAll"
                        >
                        <label :for="'all'+id"><span class="allselect">Alle</span> </label>
                    </div>
                    <transition-group name="flip-list" tag="div">
                    <div class="form-group" v-bind:key="item.value" v-for="(item, index) in filteredList"
                         v-if="options && optionsCount > 0 && index < cntVisibleOptions">
                        <div class="checkbox checkbox-primary">
                            <input type="checkbox"
                                   :id="id+item.value"
                                   :value="item.value"
                                   v-model="selectedValue">
                            <label :for="id+item.value">{{ item.text }}</label>
                        </div>
                    </div>
                   </transition-group>
                    <div class="btn-group btn-group-justified" role="group" aria-label="plusminus">
                        <div class="btn-group" role="group">
                            <button class="btn btn-default btn-xs" v-if="cntVisibleOptions > limitOptions"
                                    @click="cntVisibleOptions -= limitOptions">
                                <i class="fa fa-minus"></i> weniger
                            </button>
                        </div>
                        <div class="btn-group" role="group">
                            <button class="btn btn-default btn-xs" v-if="optionsCount > cntVisibleOptions"
                                    @click="cntVisibleOptions += limitOptions">
                                <i class="fa fa-plus"></i> mehr
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style>
.flip-list-move {
    transition: transform .75s;
}

.multiList {
    padding: 4px;
    margin: 0;
}

.multiList .checkbox {
    padding-left: 20px;
}

.multiList .checkbox label {
    display: inline-block;
    vertical-align: middle;
    position: relative;
    padding-left: 5px;
}

.multiList .checkbox label::before {
    content: "";
    display: inline-block;
    position: absolute;
    width: 17px;
    height: 17px;
    left: 0;
    margin-left: -20px;
    border: 1px solid #cccccc;
    border-radius: 3px;
    background-color: #fff;
    -webkit-transition: border 0.15s ease-in-out, color 0.15s ease-in-out;
    -o-transition: border 0.15s ease-in-out, color 0.15s ease-in-out;
    transition: border 0.15s ease-in-out, color 0.15s ease-in-out;
}

.multiList .checkbox label::after {
    display: inline-block;
    position: absolute;
    width: 16px;
    height: 16px;
    left: 0;
    top: 0;
    margin-left: -20px;
    padding-left: 3px;
    padding-top: 1px;
    font-size: 11px;
    color: #555555;
}

.multiList .checkbox input[type="checkbox"] {
    opacity: 0;
    z-index: 1;
}

.multiList .checkbox input[type="checkbox"]:focus + label::before {
    outline: thin dotted;
    outline: 5px auto -webkit-focus-ring-color;
    outline-offset: -2px;
}

.multiList .checkbox input[type="checkbox"]:checked + label::after {
    font-family: "FontAwesome";
    content: "\f00c";
}

.multiList .checkbox input[type="checkbox"]:disabled + label {
    opacity: 0.65;
}

.multiList .checkbox input[type="checkbox"]:disabled + label::before {
    background-color: #eeeeee;
    cursor: not-allowed;
}

.multiList .checkbox.checkbox-circle label::before {
    border-radius: 50%;
}

.multiList .checkbox.checkbox-inline {
    margin-top: 0;
}

.multiList .checkbox-primary input[type="checkbox"]:checked + label::before {
    background-color: #a39577;
    border-color: #a39577;
}

.multiList .checkbox-primary input[type="checkbox"]:checked + label::after {
    color: #fff;
}

.multiList .checkbox-danger input[type="checkbox"]:checked + label::before {
    background-color: #d9534f;
    border-color: #d9534f;
}

.multiList .checkbox-danger input[type="checkbox"]:checked + label::after {
    color: #fff;
}

.multiList .checkbox-info input[type="checkbox"]:checked + label::before {
    background-color: #5bc0de;
    border-color: #5bc0de;
}

.multiList .checkbox-info input[type="checkbox"]:checked + label::after {
    color: #fff;
}

.multiList .checkbox-warning input[type="checkbox"]:checked + label::before {
    background-color: #f0ad4e;
    border-color: #f0ad4e;
}

.multiList .checkbox-warning input[type="checkbox"]:checked + label::after {
    color: #fff;
}

.multiList .checkbox-success input[type="checkbox"]:checked + label::before {
    background-color: #5cb85c;
    border-color: #5cb85c;
}

.multiList .checkbox-success input[type="checkbox"]:checked + label::after {
    color: #fff;
}

.multiList .checkbox.checkbox-sm label::before {
    width: 30px;
    height: 30px;
    top: -13px;
}

.multiList .checkbox.checkbox-sm label::after {
    width: 30px;
    height: 30px;
    padding-left: 4px;
    font-size: 20px;
    left: 1px;
    top: -13px;
}

.multiList .checkbox.checkbox-sm label {
    padding-left: 18px;
    top: 13px;
}

.multiList .checkbox.checkbox-md label::before {
    width: 34px;
    height: 34px;
    top: -17px;
}

.multiList .checkbox.checkbox-md label::after {
    width: 34px;
    height: 34px;
    padding-left: 4px;
    font-size: 24px;
    left: 1px;
    top: -18px;
}

.multiList .checkbox.checkbox-md label {
    padding-left: 22px;
    top: 17px;
}

.multiList .checkbox.checkbox-lg label::before {
    width: 46px;
    height: 46px;
    top: -28px;
}

.multiList .checkbox.checkbox-lg label::after {
    width: 46px;
    height: 46px;
    padding-left: 4px;
    font-size: 36px;
    left: 1px;
    top: -31px;
}

.multiList .checkbox.checkbox-lg label {
    padding-left: 34px;
    top: 32px;
}

</style>
